import React from 'react';
import { Navbar } from '../components/Navbar';
import { Footer } from '../components/Footer';
import { PageHeroBanner } from '../components/PageHeroBanner';
import { StatsBar } from '../components/StatsBar';
import { LogoMarquee } from '../components/LogoMarquee';
import { ServiceCTABanner } from '../components/ServiceCTABanner';
import { HeartIcon, ShieldCheckIcon, UsersIcon } from 'lucide-react';
export function AboutPage() {
  return <div className="w-full min-h-screen" style={{
    fontFamily: 'Inter, sans-serif'
  }} data-id="element-839">
      <Navbar data-id="element-840" />
      <main data-id="element-841">
        {/* Section 1 — Hero */}
        <PageHeroBanner eyebrow="About Us" headline="Built on Grit. Driven by Results." subheadline="From a teenager with a pressure washer to one of the Valley's most trusted exterior cleaning companies." data-id="element-842" />

        {/* Section 2 — About Us */}
        <section className="w-full py-20 px-4" style={{
        backgroundColor: '#ffffff'
      }} data-id="element-843">
          <div className="max-w-7xl mx-auto" data-id="element-844">
            <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-16" data-id="element-845">
              {/* Left — Photo */}
              <div className="w-full lg:w-1/2" data-id="element-846">
                <div className="rounded-2xl overflow-hidden" style={{
                boxShadow: '0 20px 60px rgba(2,131,199,0.15)'
              }} data-id="element-847">
                  <img src="https://cdn.magicpatterns.com/uploads/vd6L96PFRoAVnr7dsGz1Tr/bluecactus-power-washing-andy-175A6609-683x1024.webp" alt="Andy Benedek — Founder of Blue Cactus Power Washing" className="w-full h-auto object-cover" style={{
                  maxHeight: '600px',
                  objectPosition: 'center top'
                }} data-id="element-848" />
                </div>
              </div>

              {/* Right — Text */}
              <div className="w-full lg:w-1/2" data-id="element-849">
                <h2 className="font-bold mb-6" style={{
                color: '#0283C7',
                fontFamily: 'Montserrat, sans-serif',
                fontSize: 'clamp(28px, 4vw, 34px)',
                fontWeight: 900,
                lineHeight: 1.15
              }} data-id="element-850">
                  About Us
                </h2>
                <p className="mb-4" style={{
                color: '#025A8A',
                fontFamily: 'Inter, sans-serif',
                fontSize: '16px',
                lineHeight: 1.8
              }} data-id="element-851">
                  Blue Cactus Power Washing is an insured exterior cleaning
                  company owned by Andy Benedek. Our company strives to provide
                  top quality pressure washing services.
                </p>
                <p className="mb-4" style={{
                color: '#025A8A',
                fontFamily: 'Inter, sans-serif',
                fontSize: '16px',
                lineHeight: 1.8
              }} data-id="element-852">
                  Andy Benedek has grown up in Maricopa Arizona since 2005. He
                  is a young entrepreneur as a senior in high school. Andy
                  Started his own pressure washing business due to a strong
                  desire to be self employed, as well as to provide quality,
                  honest services to the community in which he has seen grown
                  tremendously.
                </p>
                <p style={{
                color: '#025A8A',
                fontFamily: 'Inter, sans-serif',
                fontSize: '16px',
                lineHeight: 1.8
              }} data-id="element-853">
                  Blue Cactus Power Washing, formerly known as Luguensi Pressure
                  Washing, underwent a significant rebranding to better reflect
                  its commitment to quality and the vibrant spirit of the
                  Maricopa community. The new name symbolizes a fresh start and
                  a deep connection to the local environment, as cacti are
                  iconic in the Arizona landscape. This change not only enhances
                  the company's identity but also reinforces its mission to
                  deliver exceptional exterior cleaning services while embodying
                  the resilience and beauty of the Blue Cactus plant. With this
                  rebranding, Andy Benedek aims to establish a stronger presence
                  in the market, attract a wider clientele, and convey a more
                  professional image that aligns with the growth and aspirations
                  of Maricopa's rapidly developing community. As Blue Cactus
                  Power Washing, the company continues its dedication to being a
                  trusted service provider that prioritizes customer
                  satisfaction and community values.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Section 3 — Our Philosophy */}
        <section className="w-full py-20 px-4" style={{
        backgroundColor: '#E8F4FD'
      }} data-id="element-854">
          <div className="max-w-7xl mx-auto" data-id="element-855">
            <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-16" data-id="element-856">
              <div className="w-full lg:w-1/2" data-id="element-857">
                <div className="rounded-2xl overflow-hidden" style={{
                boxShadow: '0 20px 60px rgba(2,131,199,0.12)'
              }} data-id="element-858">
                  <img src="https://cdn.magicpatterns.com/uploads/u5rvnHTQ8C2zZ747ot3d8a/lpw-service-driveway-cleaning-488x650.webp" alt="Blue Cactus Power Washing — Our Philosophy" className="w-full h-auto object-cover" style={{
                  maxHeight: '420px'
                }} data-id="element-859" />
                </div>
              </div>
              <div className="w-full lg:w-1/2" data-id="element-860">
                <h2 className="font-bold mb-6" style={{
                color: '#0283C7',
                fontFamily: 'Montserrat, sans-serif',
                fontSize: 'clamp(24px, 4vw, 30px)',
                fontWeight: 900,
                lineHeight: 1.2
              }} data-id="element-861">
                  Our Philosophy
                </h2>
                <p style={{
                color: '#025A8A',
                fontFamily: 'Inter, sans-serif',
                fontSize: '16px',
                lineHeight: 1.8
              }} data-id="element-862">
                  At Blue Cactus Power Washing, we believe in delivering quality
                  power washing services that exceed our clients' expectations.
                  We strive to provide our services in a timely and efficient
                  manner, while maintaining the highest standards of safety and
                  professionalism. Blue Cactus Power Washing is an insured
                  exterior cleaning company owned by Andy Benedek. Our company
                  strives to provide top quality power washing services.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Section 3b — Our Process */}
        <section className="w-full py-20 px-4" style={{
        backgroundColor: '#ffffff'
      }} data-id="element-863">
          <div className="max-w-7xl mx-auto" data-id="element-864">
            <div className="flex flex-col lg:flex-row-reverse items-center gap-12 lg:gap-16" data-id="element-865">
              <div className="w-full lg:w-1/2" data-id="element-866">
                <div className="rounded-2xl overflow-hidden" style={{
                boxShadow: '0 20px 60px rgba(2,131,199,0.12)'
              }} data-id="element-867">
                  <img src="https://cdn.magicpatterns.com/uploads/3MyhdEBmvuewzveVgi1yVk/lpw-service-paver-cleaning-488x650.webp" alt="Blue Cactus Power Washing — Our Process" className="w-full h-auto object-cover" style={{
                  maxHeight: '420px'
                }} data-id="element-868" />
                </div>
              </div>
              <div className="w-full lg:w-1/2" data-id="element-869">
                <h2 className="font-bold mb-6" style={{
                color: '#0283C7',
                fontFamily: 'Montserrat, sans-serif',
                fontSize: 'clamp(24px, 4vw, 30px)',
                fontWeight: 900,
                lineHeight: 1.2
              }} data-id="element-870">
                  Our Process
                </h2>
                <p style={{
                color: '#025A8A',
                fontFamily: 'Inter, sans-serif',
                fontSize: '16px',
                lineHeight: 1.8
              }} data-id="element-871">
                  We use a proven process that involves a thorough assessment of
                  the surfaces to be cleaned, followed by the use of the
                  appropriate cleaning solutions and equipment. We take great
                  care to protect your property and ensure that the cleaning
                  process is safe and effective.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Section 4 — Our Values */}
        <section className="w-full py-20 px-4" style={{
        backgroundColor: '#ffffff'
      }} data-id="element-872">
          <div className="max-w-7xl mx-auto" data-id="element-873">
            <h2 className="font-bold text-center mb-14" style={{
            color: '#0283C7',
            fontFamily: 'Montserrat, sans-serif',
            fontSize: 'clamp(28px, 4vw, 36px)',
            fontWeight: 900,
            lineHeight: 1.15
          }} data-id="element-874">
              What We Stand For
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-875">
              {/* Value 1 */}
              <div className="text-center p-8 rounded-2xl" style={{
              backgroundColor: '#E8F4FD'
            }} data-id="element-876">
                <div className="w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-6" style={{
                backgroundColor: '#0283C7'
              }} data-id="element-877">
                  <HeartIcon className="h-7 w-7 text-white" data-id="element-878" />
                </div>
                <h3 className="font-bold mb-3" style={{
                color: '#0283C7',
                fontFamily: 'Montserrat, sans-serif',
                fontSize: '20px',
                fontWeight: 800
              }} data-id="element-879">
                  Positive Core Values
                </h3>
                <p style={{
                color: '#025A8A',
                fontFamily: 'Inter, sans-serif',
                fontSize: '15px',
                lineHeight: 1.7
              }} data-id="element-880">
                  Every interaction is guided by honesty, respect, and doing the
                  right thing — even when no one's watching.
                </p>
              </div>

              {/* Value 2 */}
              <div className="text-center p-8 rounded-2xl" style={{
              backgroundColor: '#E8F4FD'
            }} data-id="element-881">
                <div className="w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-6" style={{
                backgroundColor: '#0283C7'
              }} data-id="element-882">
                  <ShieldCheckIcon className="h-7 w-7 text-white" data-id="element-883" />
                </div>
                <h3 className="font-bold mb-3" style={{
                color: '#0283C7',
                fontFamily: 'Montserrat, sans-serif',
                fontSize: '20px',
                fontWeight: 800
              }} data-id="element-884">
                  Professionalism
                </h3>
                <p style={{
                color: '#025A8A',
                fontFamily: 'Inter, sans-serif',
                fontSize: '15px',
                lineHeight: 1.7
              }} data-id="element-885">
                  Licensed, bonded, and insured. We show up on time, communicate
                  clearly, and deliver consistent results.
                </p>
              </div>

              {/* Value 3 */}
              <div className="text-center p-8 rounded-2xl" style={{
              backgroundColor: '#E8F4FD'
            }} data-id="element-886">
                <div className="w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-6" style={{
                backgroundColor: '#0283C7'
              }} data-id="element-887">
                  <UsersIcon className="h-7 w-7 text-white" data-id="element-888" />
                </div>
                <h3 className="font-bold mb-3" style={{
                color: '#0283C7',
                fontFamily: 'Montserrat, sans-serif',
                fontSize: '20px',
                fontWeight: 800
              }} data-id="element-889">
                  Community First
                </h3>
                <p style={{
                color: '#025A8A',
                fontFamily: 'Inter, sans-serif',
                fontSize: '15px',
                lineHeight: 1.7
              }} data-id="element-890">
                  Born and raised in Maricopa. We support local fundraisers,
                  create local jobs, and pour back into the city that raised us.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Section — Gallery */}
        <section className="w-full py-20 px-4" style={{
        backgroundColor: '#E8F4FD'
      }} data-id="element-891">
          <div className="max-w-7xl mx-auto" data-id="element-892">
            <h2 className="font-bold text-center mb-4" style={{
            color: '#0283C7',
            fontFamily: 'Montserrat, sans-serif',
            fontSize: 'clamp(28px, 4vw, 36px)',
            fontWeight: 900,
            lineHeight: 1.15
          }} data-id="element-893">
              Our Work in Action
            </h2>
            <p className="text-center mb-12 max-w-2xl mx-auto" style={{
            color: '#025A8A',
            fontFamily: 'Inter, sans-serif',
            fontSize: '16px',
            lineHeight: 1.7
          }} data-id="element-894">
              See the quality and care we bring to every job across the Phoenix
              metro area.
            </p>
            <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4" data-id="element-895">
              {[{
              src: 'https://cdn.magicpatterns.com/uploads/ahgarkrhWBWZi14WY7Vatg/lpw-service-backyard-cleaning-488x650.webp',
              alt: 'Backyard Cleaning'
            }, {
              src: 'https://cdn.magicpatterns.com/uploads/wNfvE2GAtkNAfy1MY4Qa6Y/bcpw-service-commercial-cleaning-576x1024.webp',
              alt: 'Commercial Cleaning'
            }, {
              src: 'https://cdn.magicpatterns.com/uploads/u5rvnHTQ8C2zZ747ot3d8a/lpw-service-driveway-cleaning-488x650.webp',
              alt: 'Driveway Cleaning'
            }, {
              src: 'https://cdn.magicpatterns.com/uploads/3MyhdEBmvuewzveVgi1yVk/lpw-service-paver-cleaning-488x650.webp',
              alt: 'Paver Cleaning'
            }, {
              src: 'https://cdn.magicpatterns.com/uploads/7mkWmxZ6rJMX6ZT3SbVLdq/lpw-service-solar-panel-cleaning-577x1024.webp',
              alt: 'Solar Panel Cleaning'
            }, {
              src: 'https://cdn.magicpatterns.com/uploads/s8dNva1jhGj3tfrzpuizCn/lpw-service-trash-can-cleaning-488x650.webp',
              alt: 'Trash Can Cleaning'
            }, {
              src: 'https://cdn.magicpatterns.com/uploads/4wiNEq1mR2Agh4kR5DHda3/lpw-service-window-cleaning-600x450.webp',
              alt: 'Window Cleaning'
            }, {
              src: 'https://cdn.magicpatterns.com/uploads/vd6L96PFRoAVnr7dsGz1Tr/bluecactus-power-washing-andy-175A6609-683x1024.webp',
              alt: 'Andy Benedek at work'
            }].map((img, i) => <div key={i} className="rounded-xl overflow-hidden group cursor-pointer" style={{
              boxShadow: '0 4px 16px rgba(2,131,199,0.1)'
            }} data-id="element-896">
                  <img src={img.src} alt={img.alt} className="w-full h-56 object-cover transition-transform duration-300 group-hover:scale-105" data-id="element-897" />
                </div>)}
            </div>
          </div>
        </section>

        {/* Section 5 — Stats Bar */}
        <StatsBar data-id="element-898" />

        {/* Section 6 — Logo Marquee */}
        <LogoMarquee data-id="element-899" />

        {/* Section 7 — CTA Banner */}
        <ServiceCTABanner headline="Ready to See the Difference?" data-id="element-900" />
      </main>
      <Footer data-id="element-901" />
    </div>;
}